export default __webpack_public_path__ + "static/media/podiumIcon.617fd332.png";